import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { GridOptions } from 'ag-grid-community';
import { OutingApprovalApiService } from '../outing-approval-api.service';
@Component({
  selector: 'app-bulk-outing',
  templateUrl: './bulk-outing.component.html',
  styleUrls: ['./bulk-outing.component.scss']
})
export class BulkOutingComponent implements OnInit {
  columnDefs: any[] = [];
  rowData: any[] = [];
  selectedSection: string = '';
  admissionSearch: string = '';


  totalStudentOuting = 0;
  reasonForOuting: string = '';
  outTime: string = '';
  inTime: string = '';
  remarks: string = '';
  gridApi: any;
  gridColumnApi: any;




  filteredSections: any[] = [];

  selectedSectionId: number | null = null;
  selectedSectionName = '';
  sectionQuery = '';
  pageSize = 25;
  searchText = '';
  headerSelectAll: boolean;
  requestType: any;
  outingDate: any;
  returnDate: any;
  sectionId: any;
  reasonId: any;
  description: any;
  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    valueFormatter: (params: any) => {
      const v = params.value;
      return (v === null || v === undefined || v === "" || v === 0) ? "—" : v;
    }
  };
  sectiondata: any;
  outinglistdata: any;
  @ViewChild('searchInputsection') searchInputsection!: ElementRef;
  data1: any;
  constructor(private data: OutingApprovalApiService) { }
  ngOnInit(): void {

    this.section()
    this.outingreasons()
  }
  loadTable(section1: any) {
    this.data.getsectionwisestudent(section1).subscribe((res: any) => {


      this.columnDefs = [
        {
          headerName: '',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          width: 50,
          pinned: 'left',
          filter: false,
          sortable: false,
          suppressMenu: false
        },
        { headerName: "Adm No", field: "admNo", width: 120 },
        { headerName: "Student Name", field: "studentName", width: 200 },
        { headerName: "Father Name", field: "fatherName" },
        { headerName: "Mother Name", field: "motherName" },
        { headerName: "Guardian Name", field: "guardianName" },
        { headerName: "Total Outings", field: "totalOutings", width: 130 },
        { headerName: "Outing Days", field: "outingDays", width: 130 },

      ];
      this.rowData = res;
    });
  }

  section() {
    this.data.getsection().subscribe(res => {
      this.sectiondata = res;
      this.filteredSections = [...this.sectiondata];
    });
  }

  focusSearchcampusInput() {
    setTimeout(() => {
      if (this.searchInputsection) {
        this.searchInputsection.nativeElement.focus();
      }
    }, 100);
  }
  filterSections() {
    const q = this.sectionQuery.toLowerCase();
    this.filteredSections = this.sectiondata.filter((s: any) =>
      s.buildingName.toLowerCase().includes(q)
    );
  }
  selectSection(sec: any) {
    this.selectedSectionId = sec.sectionId;
    this.selectedSectionName = sec.sectionName;
    this.loadTable(this.selectedSectionId)
  }
  outingreasons() {
    this.data.getoutingReason().subscribe(res => {
      this.outinglistdata = res
    })
  }
  formatDateTime(dateValue: string | Date): string {
    const date = new Date(dateValue);

    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
  }
  onSelectionChanged() {
    const selectedRows = this.gridApi.getSelectedRows();

    const studentOutingDetails = selectedRows.map((row: any) => ({
      admNo: row.uniqueRefId,
      familyId: row.familyId || null
    }));

    this.totalStudentOuting = studentOutingDetails.length;
  }
  onSubmitBulkRequest() {
    const selectedRows = this.gridApi.getSelectedRows();
    const studentOutingDetails = selectedRows.map((row: any) => ({
      admNo: row.uniqueRefId,
      familyId: row.familyId || null
    }));
    this.totalStudentOuting = studentOutingDetails.length;
    const payload = {
      requestType: studentOutingDetails.length === 1 ? 'SINGLE' : 'BULK',
      outingDate: this.formatDateTime(this.outTime),
      returnDate: this.formatDateTime(this.inTime),
      reasonId: this.reasonForOuting,
      sectionId: this.selectedSectionId,
      description: this.remarks,
      studentOutingDetails: studentOutingDetails
    };
    console.log("FINAL PAYLOAD:", payload);
    // this.data.getbulkrequest(payload).subscribe(res => {
    //   this.data1 = res
    // })
    return payload;
  }
  gridOptions: GridOptions = {
    rowSelection: 'multiple',
    suppressRowClickSelection: true,
    onSelectionChanged: () => this.updateHeaderCheckbox(),
    defaultColDef: this.defaultColDef
  };
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  updateHeaderCheckbox() {
    const selected = this.gridApi.getSelectedNodes().length;
    const total = this.gridApi.getDisplayedRowCount();
    this.headerSelectAll = (selected === total && total > 0);
  }
}
